// Estados das teóricas ANAC, partilhados pela linha do aluno no painel do instrutor e pelos diálogos.
// Os estados vêm do servidor (services/anac_theory.py, student_summary).

export const ANAC_STATUS_LABEL = {
  aprovado: "aprovado",
  reprovado: "reprovado",
  marcado: "marcado",
  faltou: "faltou",
  esgotado: "esgotado",
  caducado: "caducado",
  por_fazer: "por fazer",
};

export const ANAC_STATUS_CLASS = {
  aprovado: "border-emerald-500/50 bg-emerald-500/10 text-emerald-300",
  reprovado: "border-red-500/50 bg-red-500/10 text-red-300",
  marcado: "border-sky-500/50 bg-sky-500/10 text-sky-300",
  faltou: "border-red-500/50 bg-red-500/10 text-red-300",
  esgotado: "border-red-500/50 bg-red-500/10 text-red-300",
  caducado: "border-amber-500/50 bg-amber-500/10 text-amber-300",
  por_fazer: "border-slate-600 bg-slate-800/60 text-slate-400",
};

// Dias até ao próximo exame: até 14 dias fica em destaque
export const nextExamClass = (days) =>
  days <= 14 ? "border-amber-500/60 bg-amber-500/15 text-amber-200" : "border-sky-500/40 bg-sky-500/10 text-sky-200";

export const fmtDayIso = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

// Época = mês de exame, em formato numérico: MM/AAAA (por exemplo 09/2026)
export const epochLabel = (iso) => {
  if (!iso) return "";
  const [y, m] = iso.split("-");
  return `${m}/${y}`;
};
